import { useMemo } from 'react';
import { t } from 'i18next';
import { Dialog, DialogContent } from '@datanomik/core-ui';
import { BuildingLine } from '@datanomik/core-ui/icons';

import { ClientSelector, type SelectableClient } from './ClientSelector';

interface ClientSwitcherDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clients: SelectableClient[];
  currentClientId?: string | number;
  onSelect: (client: SelectableClient) => void;
}

export function ClientSwitcherDialog({
  open,
  onOpenChange,
  clients,
  currentClientId,
  onSelect,
}: ClientSwitcherDialogProps) {
  const selectable = useMemo(
    () => clients
      .filter((client) => String(client.id) !== String(currentClientId))
      .sort((a, b) => a.company.localeCompare(b.company)),
    [clients, currentClientId],
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        icon={<BuildingLine />}
        title={t('Change client')}
        description={t('You have access to more than one account.')}
      >
        <ClientSelector
          clients={selectable}
          onSelect={(client) => {
            onSelect(client);
            onOpenChange(false);
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
